import { render } from "./CarouselC.vue?vue&type=template&id=21d1ee00&scoped=true"
import script from "./CarouselC.vue?vue&type=script&lang=js"
export * from "./CarouselC.vue?vue&type=script&lang=js"

import "./CarouselC.vue?vue&type=style&index=0&id=21d1ee00&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d1ee00"]])

export default __exports__